import { fetchWithAuth } from '../AuthService';
import { DATA_SERVICE_BASE_URL } from '../ApiService';

/**
 * Documentation API service
 * Manages documentation content using the existing document system
 */
export const DocumentationApi = {
  /**
   * Get all documentation articles
   * @param {Object} options - Filter options
   * @returns {Promise<Response>} Documentation articles response
   */
  getDocumentation: async (options = {}) => {
    const {
      section,
      page = 0,
      size = 50,
      sort = 'createdAt,desc'
    } = options;

    const qp = new URLSearchParams({
      page: String(page),
      size: String(size),
      sort
    });

    // Filter by documentation document type
    if (section) {
      qp.set('section', section);
    }

    return fetchWithAuth(`${DATA_SERVICE_BASE_URL}/api/documentation?${qp.toString()}`, {
      method: 'GET',
    });
  },

  /**
   * Get single documentation article
   * @param {string|number} documentId - Document ID
   * @returns {Promise<Response>} Documentation article response
   */
  getDocumentationArticle: async (documentId) => {
    return fetchWithAuth(`${DATA_SERVICE_BASE_URL}/api/documents/${documentId}`, {
      method: 'GET',
    });
  },

  /**
   * Search documentation
   * @param {string} query - Search query
   * @param {Object} options - Search options
   * @returns {Promise<Response>} Search results
   */
  searchDocumentation: async (query, options = {}) => {
    const { limit = 10, section } = options;
    
    return fetchWithAuth(`${DATA_SERVICE_BASE_URL}/api/documentation/search`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({
        query,
        limit,
        section
      }),
    });
  },

  /**
   * Get documentation by section
   * @param {string} section - Section name
   * @returns {Promise<Response>} Section documents response
   */
  getDocumentationBySection: async (section) => {
    return DocumentationApi.getDocumentation({ section });
  },

  /**
   * Get documentation metadata (for sidebar navigation)
   * @returns {Promise<Response>} Documentation structure response
   */
  getDocumentationStructure: async () => {
    return fetchWithAuth(`${DATA_SERVICE_BASE_URL}/api/documentation/structure`, {
      method: 'GET',
    });
  }
};
